import difference from 'lodash/difference';
import isObject from 'lodash/isObject';
import keys from 'lodash/keys';
import mergeWith from 'lodash/mergeWith';
import omit from 'lodash/omit';

import {isSignal, Signal} from '@angular/core';

export const statePartialSignals = <T extends Partial<State>, State = any>(state: State) => {
	const StateSignalss: Record<keyof T, Signal<T[keyof T]>> = {} as any;
	for (const key in state) {
		const sliceSignal = (<Record<string, unknown>>state)[key];
		if (isSignal(sliceSignal)) {
			StateSignalss[key] = sliceSignal as Signal<T[keyof T]>;
		}
	}
	return StateSignalss;
};

/* -------------------------------------------------------------------------------------------------------------- */
/**
 * Returns the difference between the local state and the updated state
 * @param localObj
 * @param updatedObj
 */
export function getStatesDiff<L extends object, U extends object>(localObj: L, updatedObj: U): Array<keyof L & keyof U> {
	if (!isObject(localObj) || !isObject(updatedObj)) {
		throw new Error('getStatesDiff: both arguments must be objects');
	}
	const keysDiff = difference(keys(updatedObj), keys(localObj));
	return keysDiff as Array<keyof L & keyof U>;
}

/**
 * Merges the local state with the updated state or any two	objects
 * @param localObj
 * @param updatedObj
 */
export function mergeStates<L extends object, U extends object>(localObj: L, updatedObj: U): Partial<L & U> {
	// validate the input
	if (!isObject(localObj) || !isObject(updatedObj)) {
		throw new Error('mergeStates: both arguments must be objects');
	}
	// merge the local state with the updated state
	const merged = mergeWith({}, localObj, updatedObj, (objValue, srcValue) => {
		if (isObject(objValue) && isObject(srcValue)) {
			return mergeStates(objValue, srcValue);
		}
		return srcValue;
	});

	// remove keys that are not in the updated state
	const keysToRemove = difference(keys(merged), keys(updatedObj));
	return omit(merged, keysToRemove);
}
/* ---------------------------------------------- Signal Store ---------------------------------------------- */
export function getStoreSignal<T>(store: T): Signal<T> {
	const [signalStateKey] = Object.getOwnPropertySymbols(store);
	if (!signalStateKey) {
		throw new Error('Cannot find State Signal');
	}

	return Object.getValueFromSymbol<Signal<T>>(store, signalStateKey);
}
